import { Link } from "@tanstack/react-router";
import { ArrowRight, Boxes, FileCheck2, Scale, ShieldCheck, Ship, Waypoints } from "lucide-react";
import { Button } from "@/components/ui/button";
import { importContent } from "@/lib/import-content";
import { pageHref, type Locale } from "@/lib/site-content";

const icons = [Boxes, FileCheck2, Scale, ShieldCheck, Ship, Waypoints];

export function ImportSection({ locale }: { locale: Locale }) {
  const t = importContent[locale];
  return <section className="section-space border-y border-border" aria-labelledby="import-title">
    <div className="site-container">
      <div className="grid gap-8 lg:grid-cols-2 lg:items-end">
        <div><p className="eyebrow text-brand">{t.eyebrow}</p><h2 id="import-title" className="section-title mt-5">{t.title}</h2></div>
        <div><p className="text-lg leading-8 text-muted-foreground">{t.lead}</p><Button asChild className="mt-6"><Link to={pageHref(locale, "contact")}>{t.cta}<ArrowRight /></Link></Button></div>
      </div>
      <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-y border-border py-5">{t.credentials.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold"><ShieldCheck className="size-4 shrink-0 text-brand" aria-hidden="true" />{item}</li>)}</ul>
      <div className="mt-12 grid gap-x-6 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
        {t.items.map(([title, text], index) => { const Icon = icons[index] ?? Boxes; return <article key={title} className="relative rounded-sm border border-border bg-card px-6 pb-7 pt-10 transition-colors hover:border-brand">
          <span className="absolute -top-5 left-6 flex size-12 items-center justify-center rounded-sm bg-brand text-brand-foreground"><Icon className="size-6" aria-hidden="true" /></span>
          <h3 className="mt-2 font-display text-xl font-semibold">{title}</h3><p className="mt-4 text-sm leading-7 text-muted-foreground">{text}</p>
        </article>; })}
      </div>
    </div>
  </section>;
}